var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheFooter',{staticStyle:{"display":"none"}},[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("© 2019 Lyxel Labs.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }